import defaultConfig from '@/assets/distributor_configs/default';
import distributor39 from '@/assets/distributor_configs/39';

export default {
  namespaced: true,
  state: {
    distributorConfig: {},
  },
  getters: {
    getShowTab: state => id => {
      // By default return true unless the tab has a value set in the config
      const config = state.distributorConfig;
      const tabs = config.tabs || {};
      if (Object.keys(tabs).indexOf(id) > -1) return tabs[id];
      return true;
    },
  },
  mutations: {
    setConfig(state, data) {
      state.distributorConfig = data;
    },
  },
  actions: {
    getConfig({ commit, dispatch }, { distributor_id }) {
      // Ensure any string gets converted
      if (!distributor_id) return;
      const distributorId = parseInt(distributor_id, 10);
      let config = defaultConfig;
      if (distributorId === 39) config = distributor39;
      commit('setConfig', config);

      dispatch(
        'translations/setCustomDistributorLabels',
        config.custom_labels,
        { root: true }
      );
    },
  },
};
